// removed by extract-text-webpack-plugin
module.exports = {"input":"_index__input___k2_jK","large":"_index__large___3P48_","fill":"_index__fill___3wHsN","label":"_index__label___1Cpi6","demo":"_index__demo___1raa-","demoHeading":"_index__demo__heading___1YYiK","demoHeadingToggle":"_index__demo__heading--toggle___3cmhD","demoHeadingToggleClosed":"_index__demo__heading--toggle--closed___3yMN2","demoNumber":"_index__demo__number____4rmw"};


//////////////////
// WEBPACK FOOTER
// ./js/_entrypoints/options-page/_index.scss
// module id = 174
// module chunks = 1